import {Vehicle} from "./vehicle";
import {Route} from "./route";
import {Trip} from "./trip";
export class Alert {
  vehicle: Vehicle;
  routeL: Route;
  time: number;
  location: number;
  trip: Trip;
  id: string;
  timestamp: string;
  vehicleId: string;
  alertType: string;
  disable: boolean;

  constructor(type, disable?: boolean) {
    this.alertType = type;
    this.disable = disable;
  }
}
